import * as c from '../constants/FilterConstants'
import {
  ARTYPE_NONSTOCKEDSSD,
  ARTYPE_ANCILLARYMATERIALS,
  ARTYPE_EXCEPTIONTESTING,
  ARTYPE_ORDERSAFTERDEADLINE,
  ARTYPE_RESHIPMENTS,
  ARTYPE_OFFCYCLETESTING,
} from '../constants/ApprovalRequestConstants'

const initialState = {
  [ARTYPE_NONSTOCKEDSSD]: {
    filter: c.APPROVAL_REQUEST_FILTERS.open.value,
    groupByAICode: false,
    filterDistantSchools: false,
    filterAiCode: '',
  },
  [ARTYPE_ANCILLARYMATERIALS]: {
    filter: c.APPROVAL_REQUEST_FILTERS.open.value,
    groupByAICode: false,
    filterDistantSchools: false,
    filterAiCode: '',
  },
  [ARTYPE_EXCEPTIONTESTING]: {
    filter: c.APPROVAL_REQUEST_FILTERS.open.value,
    groupByAICode: false,
    filterDistantSchools: false,
    filterAiCode: '',
  },
  [ARTYPE_OFFCYCLETESTING]: {
    filter: c.APPROVAL_REQUEST_FILTERS.open.value,
    groupByAICode: false,
    filterDistantSchools: false,
    filterAiCode: '',
  },
  [ARTYPE_ORDERSAFTERDEADLINE]: {
    filter: c.APPROVAL_REQUEST_FILTERS.open.value,
    groupByAICode: false,
    filterDistantSchools: false,
    filterAiCode: '',
  },
  [ARTYPE_RESHIPMENTS]: {
    filter: c.APPROVAL_REQUEST_FILTERS.open.value,
    groupByAICode: false,
    filterDistantSchools: false,
    filterAiCode: '',
  },
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case c.SET_APPROVAL_REQUEST_FILTER_OPEN:
      return {
        ...state,
        [payload.arType]: {
          ...state[payload.arType],
          filter: c.APPROVAL_REQUEST_FILTERS.open.value,
        },
      }

    case c.SET_APPROVAL_REQUEST_FILTER_CLOSED:
      return {
        ...state,
        [payload.arType]: {
          ...state[payload.arType],
          filter: c.APPROVAL_REQUEST_FILTERS.closed.value,
        },
      }

    case c.SET_APPROVAL_REQUEST_FILTER_ALL:
      return {
        ...state,
        [payload.arType]: {
          ...state[payload.arType],
          filter: c.APPROVAL_REQUEST_FILTERS.all.value,
        },
      }

    case c.SET_APPROVAL_REQUEST_GROUP_BY_AI_CODE:
      return {
        ...state,
        [payload.arType]: { ...state[payload.arType], groupByAICode: payload.groupByAICode },
      }

    case c.SET_APPROVAL_REQUEST_DISTANT_SCHOOLS:
      return {
        ...state,
        [payload.arType]: {
          ...state[payload.arType],
          filterDistantSchools: payload.filterDistantSchools,
        },
      }

    case c.SET_APPROVAL_REQUEST_AI_CODE_FILTER:
      return {
        ...state,
        [payload.arType]: {
          ...state[payload.arType],
          filterAiCode: payload.filterAiCode,
        },
      }

    default:
      return state
  }
}
